import styled from "styled-components";
import { color } from "../../../atoms/colors"
import { font } from "../../../atoms/typography"

export const DetailWrapper = styled.div`
  display: grid;
  grid-row-gap: 32px;
  @media (max-width: 992px) {
    grid-row-gap: 24px;
  }
`

export const DetailSection = styled.div`
  background: ${color.common.lightBlue};
  border-radius: 8px;
  padding: 16px;
  display: grid;
  grid-row-gap: 24px;
  @media (max-width: 576px) {
    grid-row-gap: 16px;
  }
`

export const HeadingWrap = styled.div`
  display: grid;
  grid-row-gap: 16px;
`

export const Description = styled.div`
  ${font('text', 'reg', '400')}
  display: grid;
  grid-row-gap: 16px;
  color: ${color.grey[600]};
  a {
    color: ${color.primary[800]};
    text-decoration: none;
    :hover {
      text-decoration: underline;
    }
  }
`

export const DescriptionCalc = styled.strong`
  ${font('text', 'reg', '500')}
  color: ${color.common.black};
  margin-bottom: -8px;
`

export const DetailHead = styled.h3`
  ${font('text', 'lg', '700')}
  color: ${color.common.black};
`

export const SubheadingWrap = styled.div`
  display: grid;
  grid-row-gap: 8px;
  @media (max-width: 576px) {
    margin-top: -8px;
  }
`

export const DetailSubhead = styled.span`
  ${font('text', 'lg', '700')}
  color: ${color.primary[800]};
  @media (max-width: 576px) {
    ${font('text', 'reg', '700')}
  }
`